import { useAuthStore } from "../../AuthStore/AuthStore";

export const usePermission = () => {
  const { permissionContext } = useAuthStore();

  const HasPermission = (permissions: string[]): boolean => {
    if (!permissionContext) return false;
    if(!permissions) return false;
  
    for (const p of permissions) {
      if (permissionContext.includes(p)) {
        return true;
      }
    }
  
    return false;
  };
  

  return { HasPermission };
};
